export default {
  list: [],
  listLoading: true,
  listRender: false,
  record: null,
  recordLoading: true,
  totalCount: 0
}
